var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventAvailable = function SvgEventAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#event_available_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.275 9.217-.883-.884L9.325 12.4l-1.767-1.767-.883.884 2.65 2.65zM18 2.5h-2.5V.833h-1.667V2.5H7.167V.833H5.5V2.5H3v15h15zm-1.667 13.333H4.667V6.667h11.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "event_available_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgEventAvailable;